export default class AuditFile {
	static filter(data, type) {
		let files = data.filter(file => file[type]);
		return Object.values(files).sort((a, b) => b.id - a.id);
	}
}
